import { EventStatus, eventStatusLabels, isEventStatus } from "@sp-crm/core";

export interface EventWhen {
    startsAt: string;
    timeZone: string;
}

export interface EventPlace {
    street?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

export interface EventStatusBadge {
    type: "highlight" | "success" | "error";
    label: string;
}

export const formatEventStartsAt = (when: EventWhen): string =>
    new Date(when.startsAt).toLocaleString("en-US", {
        timeZone: when.timeZone,
        weekday: "short",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short",
    });

export const formatEventDay = (when: EventWhen): { month: string; day: string } => {
    const date = new Date(when.startsAt);
    return {
        month: date.toLocaleString("en-US", { timeZone: when.timeZone, month: "short" }),
        day: date.toLocaleString("en-US", { timeZone: when.timeZone, day: "numeric" }),
    };
};

export const formatEventTime = (when: EventWhen): string =>
    new Date(when.startsAt).toLocaleString("en-US", {
        timeZone: when.timeZone,
        hour: "numeric",
        minute: "2-digit",
    });

export const eventAddressSingleLine = (place: EventPlace): string =>
    [place.street, place.city, place.state, place.zip]
        .filter(part => !!part && part.trim() !== "")
        .join(", ");

const statusBadgeTypes: Record<EventStatus, EventStatusBadge["type"]> = {
    scheduled: "highlight",
    completed: "success",
    cancelled: "error",
};

export const eventStatusBadge = (status: string): EventStatusBadge | null =>
    isEventStatus(status)
        ? { type: statusBadgeTypes[status], label: eventStatusLabels[status] }
        : null;
